import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@environment';

@Pipe({
  name: 'resizeImg',
  standalone: true,
})
export class ResizeImagePipe implements PipeTransform {
  cloudinaryURL = environment.cloudinaryURL;

  transform(url: string | null, width?: number, height?: number, transformation?: string): string | null {
    if (url && url.includes(this.cloudinaryURL.substring(7)) && this.getCurrentImageFormatFromUrl(url) !== 'svg') {
      // remove protocol - http/https
      const publicPath = url.split('upload/')[1];
      const heightParam = height ? `h_${height}` : '';
      const widthParam = width ? `w_${width}` : '';
      const transformParam = transformation ? transformation : 'c_limit';
      return `${this.cloudinaryURL}${transformParam},fl_progressive,q_auto:best,f_auto,dpr_2,${widthParam},${heightParam}/${publicPath}`;
    } else {
      return url;
    }
  }

  private getCurrentImageFormatFromUrl(url: string): string | null {
    const fileExtensionMatches = url.match(/\.([a-zA-Z0-9]+)$/);

    return fileExtensionMatches && fileExtensionMatches.length > 1 ? fileExtensionMatches[1].toLowerCase() : null;
  }
}
